import React from 'react';
import loadable from '@loadable/component';
import PropTypes from 'prop-types';
import Loading from 'Components/Loading';
import ApplicationLayout from 'Components/ApplicationLayout';
import pMinDelay from 'p-min-delay';

const Settings = loadable(() => pMinDelay(import('./Settings'), 300), {
  fallback: <Loading />
});

const CommunicationSettings = loadable(() => pMinDelay(import('./CommunicationSettings'), 300), {
  fallback: <Loading />
});

const ChangePassword = loadable(() => pMinDelay(import('./ChangePassword'), 300), {
  fallback: <Loading />
});

const PersonalizationSettings = loadable(() => pMinDelay(import('./PersonalizationSettings'), 300), {
  fallback: <Loading />
});

const AsyncSettings = props => {
  const { linkName } = props.match.params;

  let pageConfig = {
    headerType: 'full',
    footerType: 'full',
    helmet: {
      bodyAttributes: {
        class: `${ props.userAgent.device?.type } hide-betslip hide-sticky-navigation`
      },
      title: 'Bilyoner.com | Hesabım | Ayarlar'
    }
  };

  let pageContent;

  switch (linkName) {
    case 'iletisim-izinleri':
      pageContent = <CommunicationSettings { ...props }/>;
      pageConfig.helmet.title = 'Bilyoner.com | Hesabım | İletişim İzinleri';
      pageConfig.helmet.bodyAttributes.class = `${ props.userAgent.device?.type } bg-white hide-betslip hide-sticky-navigation`;
      break;
    case 'sifre-degistir':
      pageContent = <ChangePassword { ...props } />;
      pageConfig.helmet.title = 'Bilyoner.com | Hesabım | Şifre Değiştir';
      pageConfig.helmet.bodyAttributes.class = `${ props.userAgent.device?.type } bg-white hide-betslip hide-sticky-navigation`;
      break;
    case 'kisisellestirme-izinleri':
      pageContent = <PersonalizationSettings { ...props } />;
      pageConfig.helmet.title = 'Bilyoner.com | Hesabım | Kişiselleştirme İzinleri';
      pageConfig.helmet.bodyAttributes.class = `${ props.userAgent.device?.type } bg-white hide-betslip hide-sticky-navigation`;
      break;
    default:
      pageContent = <Settings { ...props }/>;
  }

  return (
    <ApplicationLayout { ...pageConfig } { ...props }>
      { pageContent }
    </ApplicationLayout>
  );
};

AsyncSettings.propTypes = {
  userAgent: PropTypes.object,
  match: PropTypes.object
};

export default AsyncSettings;
